/** @jsxImportSource @emotion/react */
import { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import {
  accessAPI,
  Boton,
  Titulo,
  Formulario,
  Sidebar,
  formatFecha,
tituloBase,
  TablaFiltrable } from "../../../shared";
import { Toast } from "primereact/toast";
import { Card } from "primereact/card";
import { Column } from "primereact/column";
import { Tag } from "primereact/tag";
import { Skeleton } from "primereact/skeleton";
import { Message } from "primereact/message";

const FILTROS_CAJAS = [];
const SEARCH_FIELDS_CAJAS = ["numero", "descripcion", "ubicacion"];

const FILTROS_MUESTRAS = [];
const SEARCH_FIELDS_MUESTRAS = [
  "numero",
  "notas",
  "productoEtiqueta",
  "_clienteRazonSocial",
];

const FILTROS_ENSAYOS = [];
const SEARCH_FIELDS_ENSAYOS = [
  "numero",
  "_muestraNumero",
  "_normaNumero",
  "_clienteRazonSocial",
];

const OPCIONES_TIPO = [
  { value: "MUESTRA", etiqueta: "Etiquetas de muestra" },
  { value: "CAJA", etiqueta: "Etiquetas de caja" },
  { value: "ENSAYO", etiqueta: "Etiquetas de ensayo" },
];

// Endpoint de lote y texto del toast por tipo de etiqueta.
const LOTE_POR_TIPO = {
  MUESTRA: { endpoint: "admin/muestra/lote", texto: "muestra" },
  CAJA: { endpoint: "admin/caja/lote", texto: "caja" },
  ENSAYO: { endpoint: "admin/ensayo/lote", texto: "ensayo" },
};

const OPCIONES_TAMANO_HOJA = [
  { value: "A4", etiqueta: "A4 (210 × 297 mm)" },
  { value: "A3", etiqueta: "A3 (297 × 420 mm)" },
  { value: "A5", etiqueta: "A5 (148 × 210 mm)" },
  { value: "LETTER", etiqueta: 'Letter (8.5" × 11")' },
  { value: "LEGAL", etiqueta: 'Legal (8.5" × 14")' },
];

export default function Muestras() {
  const [loaderMuestras, setLoaderMuestras] = useState(true);
  const [loaderCajas, setLoaderCajas] = useState(true);
  const [loaderEnsayos, setLoaderEnsayos] = useState(true);
  const [muestras, setMuestras] = useState([]);
  const [cajas, setCajas] = useState([]);
  const [ensayos, setEnsayos] = useState([]);
  const [sidebarImprimir, setSidebarImprimir] = useState(false);
  const [loaderImprimir, setLoaderImprimir] = useState(false);
  const [contadores, setContadores] = useState(null);
  // Ensayo PENDIENTE clickeado: abre el sidebar cliente → muestra para
  // registrarlo. Null = sidebar cerrado.
  const [ensayoRegistrando, setEnsayoRegistrando] = useState(null);
  const [clienteEnsayoSel, setClienteEnsayoSel] = useState(null);
  const [formRegistrarKey, setFormRegistrarKey] = useState(0);
  const toast = useRef(null);
  const navigate = useNavigate();

  useEffect(() => {
    document.title = "Muestras";
    cargarMuestras();
    cargarCajas();
    cargarEnsayos();
    cargarContadores();
    return () => (document.title = tituloBase());
  }, []);

  function cargarContadores() {
    accessAPI(
      "GET",
      "admin/muestra/contadores",
      null,
      (resp) => setContadores(resp),
      () => {},
    );
  }

  function cargarMuestras() {
    setLoaderMuestras(true);
    accessAPI(
      "GET",
      "admin/muestra",
      null,
      (resp) => {
        setMuestras(resp);
        setLoaderMuestras(false);
      },
      (resp) => {
        setLoaderMuestras(false);
        toast.current?.show({
          severity: "error",
          summary: "Error",
          detail: resp[0]?.msg || "Error al cargar muestras",
          sticky: true,
        });
      },
    );
  }

  function cargarCajas() {
    setLoaderCajas(true);
    accessAPI(
      "GET",
      "admin/caja",
      null,
      (resp) => {
        setCajas(resp);
        setLoaderCajas(false);
      },
      (resp) => {
        setLoaderCajas(false);
        toast.current?.show({
          severity: "error",
          summary: "Error",
          detail: resp[0]?.msg || "Error al cargar cajas",
          sticky: true,
        });
      },
    );
  }

  function cargarEnsayos() {
    setLoaderEnsayos(true);
    accessAPI(
      "GET",
      "admin/ensayo",
      null,
      (resp) => {
        setEnsayos(resp);
        setLoaderEnsayos(false);
      },
      (resp) => {
        setLoaderEnsayos(false);
        toast.current?.show({
          severity: "error",
          summary: "Error",
          detail: resp[0]?.msg || "Error al cargar ensayos",
          sticky: true,
        });
      },
    );
  }

  function imprimirLote(campos) {
    const cantidad = parseInt(campos.cantidad);
    const tamano = campos.tamano || "A4";
    const tipo = campos.tipo;
    if (!cantidad || cantidad < 1 || !tipo) return;
    const numeroInicial = campos.numeroInicial
      ? parseInt(campos.numeroInicial)
      : null;
    setLoaderImprimir(true);
    accessAPI(
      "POST",
      LOTE_POR_TIPO[tipo].endpoint,
      { cantidad, tamano, numeroInicial },
      (blob) => {
        setLoaderImprimir(false);
        setSidebarImprimir(false);
        const blobUrl = URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = blobUrl;
        link.download = `etiquetas-${tipo.toLowerCase()}-${Date.now()}.pdf`;
        document.body.appendChild(link);
        link.dispatchEvent(
          new MouseEvent("click", {
            bubbles: true,
            cancelable: true,
            view: window,
          }),
        );
        document.body.removeChild(link);
        URL.revokeObjectURL(blobUrl);
        toast.current?.show({
          severity: "success",
          summary: "Lote generado",
          detail: `Se generaron ${cantidad} etiqueta(s) de ${LOTE_POR_TIPO[tipo].texto}`,
        });
        if (tipo === "MUESTRA") cargarMuestras();
        if (tipo === "CAJA") cargarCajas();
        if (tipo === "ENSAYO") cargarEnsayos();
        cargarContadores();
      },
      (resp) => {
        setLoaderImprimir(false);
        toast.current?.show({
          severity: "error",
          summary: "Error",
          detail: resp[0]?.msg || "Error al generar el lote",
          sticky: true,
        });
      },
      null,
      true,
    );
  }

  const imprimirConfig = {
    secciones: [
      {
        campos: [
          {
            nombre: "tipo",
            tipoitemformularioid: 5,
            etiqueta: "Tipo de etiqueta",
            opciones: OPCIONES_TIPO,
            requerido: true,
            sinOpcionInicial: true,
          },
          {
            nombre: "cantidad",
            tipoitemformularioid: 4,
            etiqueta: "Cantidad de etiquetas",
            requerido: true,
          },
          {
            nombre: "tamano",
            tipoitemformularioid: 5,
            etiqueta: "Tamaño de hoja",
            opciones: OPCIONES_TAMANO_HOJA,
            respuesta: "A4",
            requerido: true,
          },
          {
            nombre: "numeroInicial",
            tipoitemformularioid: 4,
            etiqueta: "Número inicial (opcional — para reimpresión)",
          },
        ],
      },
    ],
    botones: [
      { etiqueta: "Generar lote", callback: imprimirLote, validar: true },
    ],
  };

  const estadoMuestra = (m) =>
    m.desactivada ? (
      <Tag value="Desactivada" severity="danger" />
    ) : m.retirada ? (
      <Tag value="Retirada" severity="warning" />
    ) : m.estado === "INGRESADA" ? (
      <Tag value="Ingresada" severity="success" />
    ) : (
      <Tag value="Pendiente" severity="info" />
    );

  const clienteBody = (m) => m.producto?.proceso?.cliente?.razonsocial || "—";

  const productoBody = (m) => m.productoEtiqueta || "—";

  const cajaBody = (m) => m.caja?.numero ?? "—";

  // Click en un ensayo: si ya está registrado va directo a la ficha de su
  // muestra; si está pendiente (etiqueta impresa sin usar) abre el sidebar
  // para elegir cliente → muestra y registrarlo allá.
  function clickEnsayo(e) {
    const ensayo = e.data;
    if (ensayo.estado === "REGISTRADO") {
      if (!ensayo.muestra?.id) return;
      if (e.originalEvent.metaKey || e.originalEvent.ctrlKey) {
        window.open(`/muestra/${ensayo.muestra.id}`, "_blank");
      } else {
        navigate(`/muestra/${ensayo.muestra.id}`);
      }
      return;
    }
    setEnsayoRegistrando(ensayo);
    setClienteEnsayoSel(null);
    setFormRegistrarKey((k) => k + 1);
  }

  // Solo se puede registrar un ensayo sobre una muestra ingresada y activa
  // con cliente conocido (vía su producto). Las opciones salen de la lista de
  // muestras ya cargada en esta pantalla.
  const muestrasElegibles = muestras.filter(
    (m) =>
      m.estado === "INGRESADA" &&
      !m.desactivada &&
      m.producto?.proceso?.cliente?.id,
  );
  const opcionesClientesEnsayo = [
    ...new Map(
      muestrasElegibles.map((m) => [
        m.producto.proceso.cliente.id,
        {
          value: m.producto.proceso.cliente.id,
          etiqueta: m.producto.proceso.cliente.razonsocial,
        },
      ]),
    ).values(),
  ].sort((a, b) => a.etiqueta.localeCompare(b.etiqueta));
  const opcionesMuestrasEnsayo = clienteEnsayoSel
    ? muestrasElegibles
        .filter((m) => m.producto.proceso.cliente.id === clienteEnsayoSel)
        .map((m) => ({
          value: m.id,
          etiqueta: `#${m.numero}${m.productoEtiqueta ? ` — ${m.productoEtiqueta}` : ""}`,
        }))
    : [];

  // Cambiar el cliente rearma el formulario para recargar el dropdown de
  // muestras; la navegación queda para el botón Seleccionar.
  function cambioFormRegistrar(campos) {
    if ("clienteId" in campos && (campos.clienteId ?? null) !== clienteEnsayoSel) {
      setClienteEnsayoSel(campos.clienteId ?? null);
      setFormRegistrarKey((k) => k + 1);
    }
  }

  // Navega a la ficha de la muestra elegida, que abre sola el sidebar de
  // registro de ensayo con este número precargado.
  function seleccionarMuestraEnsayo(campos) {
    if (!campos.muestraId) return;
    const numero = ensayoRegistrando?.numero;
    setEnsayoRegistrando(null);
    navigate(`/muestra/${campos.muestraId}`, {
      state: { registrarEnsayoNumero: numero },
    });
  }

  const estadoEnsayo = (e) =>
    e.estado === "REGISTRADO" ? (
      <Tag value="Registrado" severity="success" />
    ) : (
      <Tag value="Pendiente" severity="info" />
    );

  const tipoEnsayoBody = (e) =>
    ({
      COMPLETO: "Completo",
      SEGUIMIENTO: "Seguimiento",
      ESPECIFICO: "Específico",
    })[e.estado === "REGISTRADO" ? e.tipoEnsayo : null] || "—";

  const estadoCaja = (c) => (
    <Tag
      value={c.estado === "REGISTRADA" ? "Registrada" : "Pendiente"}
      severity={c.estado === "REGISTRADA" ? "success" : "warning"}
    />
  );

  const contenidoCaja = (c) => c.muestrasTotal ?? 0;

  const datosMuestras = (muestras || []).map((m) => ({
    ...m,
    _clienteRazonSocial: m.producto?.proceso?.cliente?.razonsocial,
  }));

  const datosEnsayos = (ensayos || []).map((e) => ({
    ...e,
    _muestraNumero: e.muestra?.numero,
    _normaNumero: e.norma?.numero,
    _clienteRazonSocial: e.proceso?.cliente?.razonsocial,
  }));

  return (
    <>
      <Toast ref={toast} position="top-center" />
      <Titulo
        botones={
          <Boton callback={() => setSidebarImprimir(true)} transparente>
            Imprimir etiquetas
          </Boton>
        }
      >
        Muestras
      </Titulo>

      <Card css={{ marginTop: "1.5rem" }}>
        <Titulo>Cajas</Titulo>
        {loaderCajas ? (
          <div css={{ display: "flex", flexDirection: "column", gap: "0.5rem" }}>
            {[...Array(4)].map((_, i) => (
              <Skeleton key={i} width="100%" height="3rem" />
            ))}
          </div>
        ) : (
          <TablaFiltrable
            value={cajas}
            filtros={FILTROS_CAJAS}
            searchFields={SEARCH_FIELDS_CAJAS}
            nombreArchivo="cajas_muestras"
            emptyMessage="No hay cajas"
            onRowClick={(e) =>
              e.originalEvent.metaKey || e.originalEvent.ctrlKey
                ? window.open(`/caja/${e.data.id}`, "_blank")
                : navigate(`/caja/${e.data.id}`)
            }
            rows={10}
            css={{ "& .p-datatable-tbody > tr": { cursor: "pointer" } }}
          >
            <Column header="N°" field="numero" />
            <Column header="Estado" body={estadoCaja} />
            <Column header="Descripción" field="descripcion" />
            <Column header="Ubicación" field="ubicacion" />
            <Column header="Muestras" body={contenidoCaja} />
          </TablaFiltrable>
        )}
      </Card>

      <Card css={{ marginTop: "1.5rem" }}>
        <Titulo>Muestras</Titulo>
        {loaderMuestras ? (
          <div css={{ display: "flex", flexDirection: "column", gap: "0.5rem" }}>
            {[...Array(4)].map((_, i) => (
              <Skeleton key={i} width="100%" height="3rem" />
            ))}
          </div>
        ) : (
          <TablaFiltrable
            value={datosMuestras}
            filtros={FILTROS_MUESTRAS}
            searchFields={SEARCH_FIELDS_MUESTRAS}
            nombreArchivo="muestras"
            emptyMessage="No hay muestras"
            onRowClick={(e) =>
              e.originalEvent.metaKey || e.originalEvent.ctrlKey
                ? window.open(`/muestra/${e.data.id}`, "_blank")
                : navigate(`/muestra/${e.data.id}`)
            }
            rows={10}
            css={{ "& .p-datatable-tbody > tr": { cursor: "pointer" } }}
          >
            <Column header="N°" field="numero" />
            <Column header="Estado" body={estadoMuestra} />
            <Column header="Cliente" body={clienteBody} />
            <Column header="Producto" body={productoBody} />
            <Column header="Caja" body={cajaBody} />
          </TablaFiltrable>
        )}
      </Card>

      <Card css={{ marginTop: "1.5rem" }}>
        <Titulo>Ensayos</Titulo>
        {loaderEnsayos ? (
          <div css={{ display: "flex", flexDirection: "column", gap: "0.5rem" }}>
            {[...Array(4)].map((_, i) => (
              <Skeleton key={i} width="100%" height="3rem" />
            ))}
          </div>
        ) : (
          <TablaFiltrable
            value={datosEnsayos}
            filtros={FILTROS_ENSAYOS}
            searchFields={SEARCH_FIELDS_ENSAYOS}
            nombreArchivo="ensayos"
            emptyMessage="No hay ensayos"
            rows={10}
            onRowClick={clickEnsayo}
            css={{ "& .p-datatable-tbody > tr": { cursor: "pointer" } }}
          >
            <Column header="N°" field="numero" />
            <Column header="Estado" body={estadoEnsayo} />
            <Column
              header="Muestra"
              body={(e) => e.muestra?.numero ?? "—"}
            />
            <Column
              header="Cliente"
              body={(e) => e.proceso?.cliente?.razonsocial || "—"}
            />
            <Column header="Norma" body={(e) => e.norma?.numero || "—"} />
            <Column header="Tipo" body={tipoEnsayoBody} />
            <Column
              header="Resultado entregado"
              body={(e) => (e.fechaResultado ? formatFecha(e.fechaResultado) : "—")}
            />
          </TablaFiltrable>
        )}
      </Card>

      <Sidebar
        visible={sidebarImprimir}
        onHide={() => setSidebarImprimir(false)}
        position="right"
        className="w-full lg:w-30rem md:w-30rem"
      >
        <h2>Imprimir etiquetas</h2>
        <p>
          Próximo número disponible:{" "}
          <strong>{contadores ? contadores.proximoMuestra : "—"}</strong> para
          muestras, <strong>{contadores ? contadores.proximoCaja : "—"}</strong>{" "}
          para cajas y{" "}
          <strong>{contadores ? contadores.proximoEnsayo : "—"}</strong> para
          ensayos.
        </p>
        <Formulario config={imprimirConfig} loader={loaderImprimir} />
      </Sidebar>

      <Sidebar
        visible={!!ensayoRegistrando}
        onHide={() => setEnsayoRegistrando(null)}
        position="right"
        className="w-full lg:w-30rem md:w-30rem"
      >
        <h2>Registrar ensayo {ensayoRegistrando?.numero}</h2>
        {opcionesClientesEnsayo.length === 0 ? (
          <Message
            severity="warn"
            css={{ width: "100%" }}
            text="No hay muestras ingresadas sobre las que registrar un ensayo."
          />
        ) : (
          <>
            <p>
              Elegí el cliente y la muestra a la que corresponde este ensayo.
              Al seleccionar se abre la ficha de la muestra con el registro
              del ensayo precargado.
            </p>
            <Formulario
              key={formRegistrarKey}
              onCambio={cambioFormRegistrar}
              config={{
                secciones: [
                  {
                    campos: [
                      {
                        nombre: "clienteId",
                        tipoitemformularioid: 5,
                        etiqueta: "Cliente",
                        opciones: opcionesClientesEnsayo,
                        respuesta: clienteEnsayoSel,
                        requerido: true,
                        sinOpcionInicial: true,
                      },
                      {
                        nombre: "muestraId",
                        tipoitemformularioid: 5,
                        etiqueta: "Muestra",
                        opciones: opcionesMuestrasEnsayo,
                        disabled: !clienteEnsayoSel,
                        requerido: true,
                        sinOpcionInicial: true,
                      },
                    ],
                  },
                ],
                botones: [
                  {
                    etiqueta: "Seleccionar",
                    callback: seleccionarMuestraEnsayo,
                    validar: true,
                  },
                ],
              }}
            />
          </>
        )}
      </Sidebar>
    </>
  );
}
